import React from 'react';
import { testimonials } from '../data/testimonials';
import { CTAButton } from './CTAButton';
export function Testimonials() {
  return <section className="px-4 py-8" data-id="element-163" data-mp="3kqw3yjl330fl">
      <div className="mx-auto max-w-4xl" data-id="element-164" data-mp="3fznsli0714zs">
        <h2 className="text-center font-display text-2xl font-black uppercase leading-tight sm:text-3xl" data-id="element-165" data-mp="3fym8yp543a6g">
          Cosa dicono i professionisti
        </h2>
        <p className="mt-1.5 text-center text-[13px] font-semibold text-graphite sm:text-sm" data-id="element-166" data-mp="36yzcmhr8ouk9">
          ⭐⭐⭐⭐⭐ 4.9/5 — Recensioni Verificate dai Professionisti
        </p>

        <div className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-167" data-mp="321z9ofpos7xd">
          {testimonials.map((testimonial, index) => <figure key={testimonial.name} className={`flex h-full flex-col rounded-xl border border-sage/40 bg-white p-4 ${index === 0 ? 'sm:col-span-2' : ''}`} data-id="element-168" data-mp="2x2ml9qj62sso" data-mpi={index}>
              <p className="text-[13px] text-mustard" aria-label="Valutazione 5 su 5" data-id="element-169" data-mp="qa3rjeqnthsd">
                ⭐⭐⭐⭐⭐
              </p>
              <blockquote className="mt-1.5 space-y-1 text-[13px] leading-snug text-graphite sm:text-sm" data-id="element-170" data-mp="h4dcylqnjo46">
                {testimonial.quote.map(line => <p key={line} data-id="element-171" data-mp="78abzj7jdvit">“{line}”</p>)}
              </blockquote>
              <figcaption className="mt-auto pt-2.5" data-id="element-172" data-mp="c6llfstx640i">
                <p className="font-display text-sm font-extrabold uppercase leading-tight text-petrol" data-id="element-173" data-mp="c7dfv0bs5vp7">
                  {testimonial.name}
                </p>
                <p className="text-xs text-graphite/80" data-id="element-174" data-mp="14w2dgpdmniw7">
                  {testimonial.role} — {testimonial.city}
                </p>
              </figcaption>
            </figure>)}
        </div>

        <CTAButton className="mx-auto mt-5 max-w-lg" data-id="element-175" data-mp="v4xuzfoqtfwm" />
      </div>
    </section>;
}